import { useParams } from "react-router-dom";
import { useState, useEffect, useRef, useCallback} from "react";
import { Divider, Row, Col, Button, Table, Input, Checkbox, InputNumber, Spin, 
        Tag, Space, Dropdown, Tooltip, message, Modal, Pagination } from "antd";
import { getLabAssignmentReport, exportToExcel, updateLabAssignmetReport, getAiCodeFeedback,fetchResourceLabQuestion } from '../../services/ide-apis';
import { ReactComponent as PdfIcon } from '../../assets/logos/pdf Icon.svg';
import { ReactComponent as ExcelIcon } from '../../assets/logos/excel icon.svg';
import { trackEvent, formatDateMonth, isMobile, getIdeProjectTypeMetaData } from '../utils/util-functions';
import { ReactComponent as MoreIcon } from '../../assets/logos/more icon.svg';
import { global_var } from "../../services/cs-lab-config";
import { ReactComponent as QuestionInfo } from '../../assets/logos/Question_Info.svg';
import ProjectFilters from "../utils/project-filters";
import { ReactComponent as ShowCode } from '../../assets/logos/show code.svg';
import { ReactComponent as ViewSourceCode } from '../../assets/logos/viewSourceCode.svg';
import SourceCodeModal from '../labAssignments/view-source-code-modal';
import ModalComponent from '../labAssignments/assignment-details-modal';
import BackBtn from '../utils/back-btn';

const AssignmentReport = () => {

    let { resourceId, labQuestionMappingId } = useParams();
    const [report, setReport] = useState({});
    const [isEvaluatedLoading, setIsEvaluatedLoading] = useState(true);
    const [isCompletedLoading, setIsCompletedLoading] = useState(true);
    const [isPendingLoading, setIsPendingLoading] = useState(true);
    const [isResubmitLoading, setIsResubmitLoading] = useState(true);
    const [exportExcelLoading, setExportExcelLoading] = useState(false);
    const [exportPdfLoading, setExportPdfLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [saveLoader, setSaveLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [filterModal, setFilterModal] = useState(false);
    const [exportType, setExportType] = useState('');
    const [questionTitle, setQuestionTitle] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [crmId, setCrmId] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [checked, setChecked] = useState([]);
    const [modifiedData, setModifiedData] = useState([]);
    const [projectChecked, setProjectChecked] = useState({
        evaluated: true,
        submitted: true,
        pending: true,
        resubmit:true,
    });
    const [reportKey, setReportKey] = useState(0);
    const [completedKey, setCompletedKey] = useState(0);
    const [pendingKey, setPendingKey] = useState(0);
    const [resubmitKey, setResubmitKey] = useState(0);
    const [evaluatedPageNo] = useState(1);
    const [completedPageNo] = useState(1);
    const [pendingPageNo] = useState(1);
    const [resubmitPageNo] = useState(1);
    const [studentMappings, setStudentMappings] = useState([]);
    const [selectedProject, setSelectedProject] = useState([]);
    const [isOpenModal, setIsOpenModal] = useState(false);


    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [dropdownClicked, setDropdownClicked] = useState(false);
    const [pendingDataCount, setPendingDataCount] = useState(0);
    const [evaluatedDataCount, setEvaluatedDataCount] = useState(0);
    const [completedDataCount, setCompletedDataCount] = useState(0);
    const [resubmitDataCount, setResubmitDataCount] = useState(0);
    const [hideEvaluatedData, setHideEvaluatedData] = useState(false);
    const [hideSubmittedData, setHideSubmittedData] = useState(false);
    const [hidePendingData, setHidePendingData] = useState(false);
    const [hideResubmitData, setHideResubmitData] = useState(false);
    const [totalCount, setTotalCount] = useState();
    const [projectType, setProjectType] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [currentRecord, setCurrentRecord] = useState([]);

    const fetchEvaluatedDataRef = useRef(fetchEvaluatedData);
    const fetchPendingDataRef = useRef(fetchPendingData);
    const fetchSubmittedDataRef = useRef(fetchSubmittedData);
    const fetchResubmitDataRef = useRef(fetchResubmissionData);
    const [showScoreColumn, setShowScoreColumn] = useState(false);
    let exportDataRef = useRef({});

   
    const filtersChanged = useCallback((filters) => {
        exportDataRef.current = {
            ...filters,
            fkCompanyId: global_var.company_id,
            from: "csLab"
          };

        fetchPendingDataRef.current(pendingPageNo);
        fetchSubmittedDataRef.current(completedPageNo);
        fetchEvaluatedDataRef.current(evaluatedPageNo);
        fetchResubmitDataRef.current(resubmitPageNo);
        if(filters.evaluationStatus){
            if(filters.evaluationStatus === 'Evaluated'){
                setHideSubmittedData(true)
                setHideResubmitData(true)
                setHidePendingData(true)
                setHideEvaluatedData(false)

                setProjectChecked(prevState => ({
                    ...prevState,
                    submitted: false,
                    pending: false,
                    resubmit:false,
                    evaluated:true,
                }));
            }
            if(filters.evaluationStatus === 'Ask for resubmission'){
                setHideEvaluatedData(true)
                setHideSubmittedData(true)
                setHidePendingData(true)
                setHideResubmitData(false)
                setProjectChecked(prevState => ({
                    ...prevState,
                    evaluated:false,
                    submitted: false,
                    pending: false,
                    resubmit:true,
                }));

            }
            if(filters.evaluationStatus === 'submittedForEvaluation'){
                setHideEvaluatedData(true)
                setHideResubmitData(true)
                setHideSubmittedData(false)
                setHidePendingData(true)
                setProjectChecked(prevState => ({
                    ...prevState,
                    evaluated:false,
                    submitted: true,
                    pending: false,
                    resubmit:false,
                }));

            }
            if(filters.evaluationStatus === 'Pending submission'){
                setHideEvaluatedData(true)
                setHideResubmitData(true)
                setHideSubmittedData(true)
                setHidePendingData(false)
                setProjectChecked(prevState => ({
                    ...prevState,
                    evaluated:false,
                    submitted: false,
                    pending: true,
                    resubmit:false,
                }));

            }
        }
    }, [evaluatedPageNo,pendingPageNo,completedPageNo, resubmitPageNo]);

    const getResourceLabQuestion = async(resourceId)=>{
        try {
            const response = await fetchResourceLabQuestion(resourceId);
            if (response.data.statusCode === 200) {
                setSelectedProject(response.data.labQuestion);
                setTimeout(() => {
                    setIsOpenModal(true);
                  }, 0);
            } else {
                console.error("Failed to fetch lab questions:", response.data.message);
            }
        } catch (error) {
            console.error("Error fetching lab questions:", error);
        }
    }

    function fetchEvaluatedData(evaluatedPageNo){
        setIsEvaluatedLoading(true)                  
        exportDataRef.current.filteredData = {evaluated: true,submitted: false,pending: false, resubmit:false}
        exportDataRef.current.pageNo = evaluatedPageNo
        exportDataRef.current.limitCount = 10

        getLabAssignmentReport(resourceId,labQuestionMappingId,exportDataRef.current).then((response) => {
            response = response.data
            if (response.statusCode === 200) {
                report['evaluated'] = {}
                
                if (response.reportObj && response.reportObj.organizedData) {    
                    report['evaluated'] = response.reportObj.organizedData.evaluated
                    setReport(report)
                    setReportKey(reportKey + 1);
                    if(response.reportObj.organizedData.evaluated){
                        if ( response.reportObj.organizedData.evaluated &&
                            response.reportObj.organizedData.evaluated.length > 0 &&
                            response.reportObj.organizedData.evaluated[0].totalMark) {
                            setShowScoreColumn(true); 
                        }
                    } 
                }
               
                setEvaluatedDataCount(response.reportObj.categoryCount)
                setQuestionTitle(response.reportObj.questionTitle)
                setSelectedDate(response.reportObj.createdDate)
                setSelectedClass(response.reportObj.currentClass)
                if (response?.reportObj?.crmId) {
                    setCrmId(response.reportObj.crmId)
                }
                if (response?.reportObj?.studentMappings) {
                    setStudentMappings(response.reportObj.studentMappings);
                }
                setIsEvaluatedLoading(false)
                setProjectType(response.reportObj.projectType)
            }   
        })
    }
    function fetchPendingData(pendingPageNo){
        setIsPendingLoading(true)                  
        exportDataRef.current.filteredData = {evaluated: false, submitted: false, pending: true, resubmit:false};
        exportDataRef.current.pageNo = pendingPageNo;
        exportDataRef.current.limitCount = 10;
        getLabAssignmentReport(resourceId,labQuestionMappingId,exportDataRef.current).then((response) => {
            response = response.data
            if (response.statusCode === 200) {
                report['pending'] = {}
                if (response.reportObj && response.reportObj.organizedData) {
                report['pending'] = response.reportObj.organizedData.pending
                setReport(report)
                setPendingKey(pendingKey+1)
                }
                setPendingDataCount(response.reportObj.categoryCount)
                setQuestionTitle(response.reportObj.questionTitle)
                setSelectedDate(response.reportObj.createdDate)
                setSelectedClass(response.reportObj.currentClass)
                if (response?.reportObj?.crmId) {
                    setCrmId(response.reportObj.crmId)
                }
                if (response?.reportObj?.studentMappings) {
                    setStudentMappings(response.reportObj.studentMappings);
                }
                setIsPendingLoading(false)                     
            }
        })
    }
    
    function fetchSubmittedData(completedPageNo){
        setIsCompletedLoading(true)                  
        exportDataRef.current.filteredData = {evaluated: false, submitted: true, pending: false, resubmit:false};
        exportDataRef.current.pageNo = completedPageNo;
        exportDataRef.current.limitCount = 10;
        getLabAssignmentReport(resourceId,labQuestionMappingId,exportDataRef.current).then((response) => {
            response = response.data
            if (response.statusCode === 200) {
                report['completed'] = {}
                if (response.reportObj && response.reportObj.organizedData) {
                    report['completed'] = response.reportObj.organizedData.completed;
                    setReport(report);
                    setCompletedKey(completedKey + 1);
                    setCompletedDataCount(response.reportObj.categoryCount)
                }
                setCompletedDataCount(response.reportObj.categoryCount)
                setQuestionTitle(response.reportObj.questionTitle)
                setSelectedDate(response.reportObj.createdDate)
                setSelectedClass(response.reportObj.currentClass)
                if (response?.reportObj?.crmId) {
                    setCrmId(response.reportObj.crmId)
                }
                if (response?.reportObj?.studentMappings) {
                    setStudentMappings(response.reportObj.studentMappings);
                }
                setIsCompletedLoading(false)                
            }
        })
    }

    function fetchResubmissionData(resubmitPageNo){
        setIsResubmitLoading(true)                  
        exportDataRef.current.filteredData = {evaluated: false, submitted: false, pending: false, resubmit:true};
        exportDataRef.current.pageNo = resubmitPageNo;
        exportDataRef.current.limitCount = 10;
        getLabAssignmentReport(resourceId,labQuestionMappingId,exportDataRef.current).then((response) => {
            response = response.data
            if (response.statusCode === 200) {
                report['resubmit'] = {}
                if (response.reportObj && response.reportObj.organizedData) {
                    report['resubmit'] = response.reportObj.organizedData.Ask_for_resubmit;
                    setReport(report);
                    setResubmitKey(resubmitKey + 1);
                    setCompletedDataCount(response.reportObj.categoryCount)
                }
                setResubmitDataCount(response.reportObj.categoryCount)
                setQuestionTitle(response.reportObj.questionTitle)
                setSelectedDate(response.reportObj.createdDate)
                setSelectedClass(response.reportObj.currentClass)
                if (response?.reportObj?.crmId) {
                    setCrmId(response.reportObj.crmId)
                }
                if (response?.reportObj?.studentMappings) {
                    setStudentMappings(response.reportObj.studentMappings);
                }
                setIsResubmitLoading(false)                
            }
        })
    }
    function renderMappings(studentMappings, transform) {
        let text = '';
        studentMappings.forEach((mapping, index) => {
            if(mapping.className ){
            text = text + ' ' + mapping.className + ' '
            }
            if(mapping.divisionName){
                text = text + ' ' + mapping.divisionName  + ' ';
            }
            if(mapping.streamName){
                text = text + ' ' + mapping.streamName  + ' ';
            }
            if (mapping.individualStudents && Array.isArray(mapping.individualStudents)) {
                mapping.individualStudents.forEach((student, studentIndex) => {
                    text += ' ' + student.Name; 
                    if (studentIndex < mapping.individualStudents.length - 1) {
                        text += ' , '; 
                    }
                });
            }
            if(index < studentMappings.length -1){
                text = text + ', '
            }
        });

        if(transform && text.length > 40 ){
            text = text.slice(0, 40) + '... ';
        }
        return text;
    }

    useEffect(()=>{
        let totalStudents = 0;
        if(evaluatedDataCount){
            totalStudents += evaluatedDataCount
        }

        if(completedDataCount){
            totalStudents += completedDataCount
        }

        if(pendingDataCount){
            totalStudents += pendingDataCount
        }
        setTotalCount(totalStudents)
    },[evaluatedDataCount, completedDataCount, pendingDataCount])

    const isSupervisor = useCallback(() => {
        if ( global_var.role_id === global_var.SUPERVISOR_ROLE_ID || global_var.role_id === global_var.SUPERVISOR_ROLE_IDS) {
          return global_var.roleMappingId !== crmId;
        }
        return false;
    }, [crmId]);  

    const columns = [
        {
            title: 'Student Name',
            dataIndex: 'name',
            key: 'name',
            width: selectedClass ? 140 : 220,
            showInPending: true,
            showInSubmitted: true,
            showInExpandable:true,
            render: (_, record) => {
                if (isMobile) {
                    return (
                        <span>
                            <span className="poppins-regular" style={{fontSize:'16px',color:'#404040'}}>{record.name}</span>
                            {selectedClass &&(
                                <p className="text-midgrey poppins-regular">
                                {record.class && <span><span style={{color:'#111111'}}>{record.class}</span></span>}
                                {record.division && <span><span style={{color:'#111111'}}>{record.division}</span></span>}</p>
                            )}
                        </span>
                    );
                }
                return (
                    <span className="poppins-regular" style={{fontSize:'12px',color:'#404040'}}>
                        {record.name} 
                    </span>
                )
            },
        },
    ]
    if (selectedClass){
        columns.push(
            {
                title: 'Class',
                dataIndex: 'class',
                key: 'class',
                showInPending: true,
                showInSubmitted: true,
                showInExpandable:false,
    
                render: (_, record) => {
                    
                    if (!isMobile) {
                        return (
                            <span className="poppins-regular" style={{fontSize:'12px',color:'#404040'}}>
                                {record.class}
                                {record.division && <span>{record.division}</span>}
                            </span>
                        );
                    }
                }
            },
        )
    }
    if (showScoreColumn) {
    columns.push(
        {
            title: 'Score',
            dataIndex: 'markScored',
            key: 'markScored',
            showInPending: false,
            showInSubmitted: false,
            showInExpandable:true,

            render: (score, record) => 
            <div>
                {isMobile && <span className="poppins-regular" style={{fontSize:'16px'}}>Score </span>}
                <InputNumber
                    className="poppins-regular"
                    style={{ width: '45px'}}
                    defaultValue={score}
                    onChange={(defaultValue) => handleInputChange(defaultValue, 'markScored', record._id)}
                    max={record.totalMark ? record.totalMark : undefined}
                    min={0} 
                    onKeyPress={(e) => {
                        if (!/^\d$/.test(e.key)) {
                            e.preventDefault();
                        }
                    }}
                    />
            </div>
        }
    )}
    columns.push(
        {
            title: 'Feedback',
            dataIndex: 'evaluationFeedback',
            key: 'evaluationFeedback',
            width:300,
            showInPending: false,
            showInSubmitted: false,
            showInExpandable:false,

            render: (feedback, record) => (
                <Input.TextArea
                    className="poppins-regular"
                    rows={4}
                    defaultValue={feedback}
                    onChange={(event) => handleInputChange(event.target.value, 'evaluationFeedback', record._id)}
                    style={{borderColor:'#D7BEF7',fontSize:'12px',color:'#404040'}}
                />
            ),
        },
        {
            title: 'Improvement',
            dataIndex: 'evaluationImprovement',
            key: 'evaluationImprovement',
            width:300,
            showInPending: false,
            showInSubmitted: false,
            showInExpandable:false,
            render: (improvement, record) => (
                <Input.TextArea
                    className="poppins-regular"
                    defaultValue={improvement}
                    rows={4}
                    onChange={(event) => handleInputChange(event.target.value, 'evaluationImprovement', record._id)}
                    style={{fontSize:'12px',color:'#404040'}}
                />
            ),
        },
    )

        columns.push(
            {
                showInExpandable: true,
                render: (_, record) => {
                    const isExpanded = expandedRowKeys.includes(record._id);
                    if (isMobile && isExpanded) {
                        return (
                            <Space size="small">
                                <Tooltip title={'Open Project'}>
                                    <span onClick={() => navigateToIDE(record)}>
                                        <ShowCode style={{ cursor: 'pointer' }} />
                                    </span>
                                </Tooltip>

                                {(projectType !== 'vc3' && projectType !== 'sql2') && (
                                    <>
                                        <Tooltip title={'View Code'}>
                                            <span onClick={() => handleOpenModal(record)}>
                                                <ViewSourceCode style={{ cursor: 'pointer' }} />
                                            </span>
                                        </Tooltip>

                                        <Tooltip title={'More'}>
                                            <Dropdown
                                                menu={{ items: generateItems(record) }}
                                                trigger={["click"]}
                                                onClick={() => setDropdownClicked(true)}
                                            >
                                                <span onClick={(e) => e.preventDefault()}>
                                                    <Space>
                                                        <MoreIcon style={{ cursor: 'pointer' }} />
                                                    </Space>
                                                </span>
                                            </Dropdown>
                                        </Tooltip>
                                    </>
                                )}
                            </Space>
                        );
                    } else if (!isMobile) {
                        return (
                            <Space size="small">
                                <Tooltip title={'Open Project'}>
                                    <span onClick={() => navigateToIDE(record)}>
                                        <ShowCode style={{ cursor: 'pointer' }} />
                                    </span>
                                </Tooltip>
                                {(projectType !== 'vc3' && projectType !== 'sql2') && (
                                    <>
                                        <Tooltip title={'View Code'}>
                                            <span onClick={() => handleOpenModal(record)}>
                                                <ViewSourceCode style={{ cursor: 'pointer' }} />
                                            </span>
                                        </Tooltip>

                                        <Tooltip title={'More'}>
                                            <Dropdown
                                                menu={{ items: generateItems(record) }}
                                                trigger={["click"]}
                                                onClick={() => setDropdownClicked(true)}
                                            >
                                                <span onClick={(e) => e.preventDefault()}>
                                                    <Space>
                                                        <MoreIcon style={{ cursor: 'pointer' }} />
                                                    </Space>
                                                </span>
                                            </Dropdown>
                                        </Tooltip>
                                    </>
                                )}
                            </Space>
                        );
                    }
                    return null;
                },
            },
        );

    const generateItems = (record) => [
        {
            label: <Button className="cancel-button" style={{width:'160px'}}>Clear Feedback</Button>,
            key: '1',
            onClick: () => handleClearFeedback(record),
        },
        {
            label: <Button className="cancel-button"  style={{width:'160px'}}>Restore AI Feedback</Button>,
            key: '2',
            onClick: () => handleAiFeedback(record),
        },
    ];
    const columnsPending = columns.filter(col => col.showInPending);
    const columnsSubmitted = columns.filter(col => col.showInSubmitted);
    const columnsExpandable = columns.filter(col => col.showInExpandable); 

    useEffect(() => {
        const initialCheckedState = Array(columns.length).fill(true); 
        setChecked(initialCheckedState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleCheckboxChange(columnIndex) {
        setChecked(prevChecked => {
            const updatedChecked = [...prevChecked]; 
            updatedChecked[columnIndex] = !updatedChecked[columnIndex]; 
            return updatedChecked;
        });
    }

    const handleProjectCheckboxChange = (checkbox) => {
        setProjectChecked(prevState => ({
            ...prevState,
            [checkbox]: !prevState[checkbox]
        }));
    };

    function handleToExport(type) {
        setExportType(type);
        setIsModalOpen(true);
    }

    function handleExport() {
        if(saveLoading){
            setShowModal(true);

        }else{
            const checkedColumns = columns.slice(0, -1)
                .filter((column, index) => checked[index]) // Filter selected columns based on checked state
                .map(column => column.dataIndex); // Get the dataIndex of selected columns

            const exportData = {
                checkedColumns: checkedColumns,
                isDownload: exportType, 
                filteredData: projectChecked, 
            };

            trackEvent("export_lab_assignment_button_clicked",{});

            if (exportType === 'excel') {
                setExportExcelLoading(true);
            } else {
                setExportPdfLoading(true);
            }
            exportToExcel(resourceId,labQuestionMappingId, exportData).then((response) => {
                    const contentType = exportType === 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf';
                    const blob = new Blob([response.data], { type: contentType });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = "lab assignment report";
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    setIsModalOpen(false);

                }).catch(error => {
                    console.error('Error exporting to Excel:', error);
                    setShowModal(false); // Close modal on error
                })
                .finally(() => {
                    setExportExcelLoading(false);
                    setExportPdfLoading(false);
                });
        }
    }

    function navigateToIDE(projectObj) {
        if(isSupervisor()){
            message.warning("You are not authorized to view this project");
            return;
        }
        const projectMetaData = getIdeProjectTypeMetaData(
          projectObj.projectType
        );
        trackEvent("auto_evaluate_page_ide_button_clicked", {
          ide_project_stack_name: projectObj.projectType,
        });
    
        if (projectMetaData ? projectMetaData.route : false) {
            const fkResourceIdParam = projectObj.fkResourceId ? projectObj.fkResourceId : '';
            let url = '';

            if (projectObj.projectType === "sql2") {
                url = `${projectMetaData.route}${projectObj.queryId}?fkResourceId=${fkResourceIdParam}`;
              } else if (projectObj.projectType === "vc3") {
                url = `${projectMetaData.route}${projectObj.projectId}?isEval=true&fkResourceId=${fkResourceIdParam}`;
              } else {
                url = `${projectMetaData.route}${projectObj.projectId}`;
              }
        
            window.open(url, '_blank');
        } else {
        message.info("Coming soon.");
        }
    }
    
    const handleOpenModal = (record) => {
        setCurrentRecord(record);
        setIsOpen(true);
    };

    const handleCancel = () => {
        setIsOpen(false);
        setIsOpenModal(false);
      };

    const handleInputChange = (value, dataIndex, recordKey) => {
        setSaveLoading(true)
        const existingRecordIndex = modifiedData.findIndex(record => record._id === recordKey);
        if (existingRecordIndex !== -1) {
            const updatedData = [...modifiedData];
            updatedData[existingRecordIndex] = {
                ...updatedData[existingRecordIndex],
                [dataIndex]: value
            };
            setModifiedData(updatedData);

            const updatedReport = {
                ...report,
                evaluated: report.evaluated.map(item => {
                    if (item._id === recordKey) {
                        return {
                            ...item,
                            [dataIndex]: value
                        };
                    }
                    return item;
                })
            };
            setReport(updatedReport);
        } else {
            const newRecord = {
                _id: recordKey,
                [dataIndex]: value
            };
            setModifiedData(prevData => [...prevData, newRecord]);
        }        
    };

    const handleAiFeedback = (record) => {
        if(isSupervisor()){
            message.warning("You are not authorized to perform this action");
            return;
        }
        setSaveLoading(true)
        getAiCodeFeedback(record.projectId).then((response) => {
            response = response.data;
            if (response.statusCode === 200) {
                let feedbackResponse = response?.aiFeedback?.feedback;
                if(response?.aiFeedback?.error != null){
                    feedbackResponse = response?.aiFeedback?.error
                }
                const updatedRecord = {
                    ...record,
                    evaluationFeedback:  feedbackResponse || '',
                    evaluationImprovement: response?.aiFeedback?.improvement,
                    markScored: parseFloat(response?.aiFeedback?.score)
                };
                const recordIndex = report.evaluated.findIndex(item => item._id === record._id);
                if (recordIndex !== -1) {
                    const updatedEvaluated = [...report.evaluated];
                    updatedEvaluated[recordIndex] = updatedRecord; 
                    const updatedReport = {
                        ...report,
                        evaluated: updatedEvaluated
                    };
                    setReport(updatedReport); 
                    setReportKey(reportKey + 1);
                }

                const existingRecordIndex = modifiedData.findIndex(item => item._id === record._id);
                if (existingRecordIndex !== -1) {
                    const updatedData = [...modifiedData];
                    updatedData[existingRecordIndex] = {
                        ...updatedData[existingRecordIndex],
                        evaluationFeedback: updatedRecord.evaluationFeedback,
                        evaluationImprovement: updatedRecord.evaluationImprovement,
                        markScored: updatedRecord.markScored
                    };
                    setModifiedData(updatedData);
                } else {
                    const newRecord = {
                        _id: record._id,
                         evaluationFeedback: updatedRecord.evaluationFeedback,
                        evaluationImprovement: updatedRecord.evaluationImprovement,
                        markScored: updatedRecord.markScored
                    };
                    setModifiedData(prevData => [...prevData, newRecord]);
                }
            } else {
              message.error(response.message);
            }
        });
    }

    const handleClearFeedback = (record) => {
        if(isSupervisor()){
            message.warning("You are not authorized to perform this action");
            return;
        }
        const recordIndex = report.evaluated.findIndex(item => item._id === record._id);
        const updatedRecord = {
            ...record,
            evaluationFeedback: '',
            evaluationImprovement: '',
            markScored: ''
        };
        if (recordIndex !== -1) {
            const updatedEvaluated = [...report.evaluated];
            updatedEvaluated[recordIndex] = updatedRecord; 
            const updatedReport = {
                ...report,
                evaluated: updatedEvaluated
            };
            setReport(updatedReport);
            setReportKey(reportKey + 1);
        }

        const existingRecordIndex = modifiedData.findIndex(item => item._id === record._id);
        if (existingRecordIndex !== -1) {
            const updatedData = [...modifiedData];
            updatedData[existingRecordIndex] = {
                ...updatedData[existingRecordIndex],
                evaluationFeedback: '',
                evaluationImprovement: '',
                markScored: ''
            };
            setModifiedData(updatedData);
        } else {
            const newRecord = {
                _id: record._id,
                evaluationFeedback: '',
                evaluationImprovement: '',
                markScored: ''
            };
            setModifiedData(prevData => [...prevData, newRecord]);
        }
        setReportKey(reportKey + 1);
    }

    const handleSaveChanges = () => {
        setSaveLoader(true)
        updateLabAssignmetReport(resourceId,labQuestionMappingId,modifiedData).then((response) => {
            response = response.data
            if (response.statusCode === 200) {
                message.success(response.message);                     
                setSaveLoading(false)
                setSaveLoader(false)
            }
        })
    }

    const handleRowClick = (record) => {
        if (!dropdownClicked) {
            const newExpandedRowKeys = [...expandedRowKeys];
            const keyIndex = newExpandedRowKeys.indexOf(record._id);
            if (keyIndex > -1) {
                newExpandedRowKeys.splice(keyIndex, 1);
            } else {
                newExpandedRowKeys.push(record._id);
            }
            setExpandedRowKeys(newExpandedRowKeys);
        }
        setDropdownClicked(false);
    };

      
    return (
        <>
            <Row className=" fixed-top p-2" style={{backgroundColor:'#fef8f8' , zIndex: 1}}>
                <Col
                    className="col d-flex align-items-center"
                    justify="space-evenly"
                    align="middle"
                    >
                    <BackBtn />
                    <span className="m-1 mt-2 h4 poppins-medium">Assignment Report</span>
                </Col>
                <Col className="mt-2">

                    <Button className="cancel-button mx-2 poppins-medium text-dark" 
                        onClick={() => getResourceLabQuestion(resourceId)}
                        > <QuestionInfo style={{marginRight:'8px'}} /> View Question
                    </Button>
                    <Button className="cancel-button mx-2 poppins-medium text-dark" 
                        onClick={() => {
                            if (isMobile) {
                                setExportType('pdf')
                                setFilterModal(true);
                            } else {
                                handleToExport('pdf');
                            }
                        }}
                        style={{boxShadow: '0px 12px 14px rgba(233, 99, 88, 0.2)'}}
                        loading={exportPdfLoading}
                        ><PdfIcon style={{marginRight:'8px'}} /> Export as pdf
                    </Button>
                    <Button className="cancel-button poppins-medium text-dark" 
                        style={{boxShadow: '0px 12px 14px rgba(233, 99, 88, 0.2)'}}
                        onClick={() => {
                            if (isMobile) {
                                setExportType('excel')
                                setFilterModal(true);
                            } else {
                                handleToExport('excel');
                            }
                        }}
                        loading={exportExcelLoading}
                        ><ExcelIcon style={{marginRight:'8px'}} /> Export as xlxs
                    </Button>
                    {!isSupervisor() && (
                        <Button type="primary" className=" mx-2 create-button poppins-medium"
                            style={{ boxShadow: "0px 12px 14px rgba(233, 99, 88, 0.2)" }}
                            onClick={handleSaveChanges}
                            loading={saveLoader}
                        >Save Changes
                        </Button>
                    )}
                </Col>
            </Row>
            <Modal
                title='Export'
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width={350}
                style={{
                  top: 60,
                  right: 50,
                  position: "fixed",
                }}
            >
                <div>
                    {columns.slice(0, columns.length - 1).map((column, index) => (
                        <div key={column.key} className="poppins-regular" style={{ fontSize: '16px', paddingTop: '6px', color: '#404040' }}>
                            <Checkbox
                                checked={checked[index]} // Ensure this is linked correctly with the checkbox
                                onChange={() => handleCheckboxChange(index)} // Handle change when checkbox is clicked
                            />
                            <span style={{ fontSize: '14px', color: '#404040' ,paddingLeft:'10px' }}>{column.title}</span>
                        </div>
                    ))}
                </div>
                <Button
                    type="primary"
                    block
                    onClick={handleExport}
                    style={{
                        marginTop: "15px",
                    }}
                    >
                    Export
                </Button>
            </Modal>

            <Divider className="d-none d-md-block" style={{backgroundColor:"#D7BEF7", marginTop:'60px'}}/>

            <ProjectFilters
                filtersChanged={filtersChanged}
                hideUserFilter ={false} 
                hideAcademicYearFilter = {true}
                hideProjectTypeFilter = {true}
                hideDateFilter = {true}
                hideProjectNameFilter={true}
                hidePaginationFilter={true} 
                hidePendingEvaluationOption={true}
                hideClassFilter ={global_var.needClass && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true} 
                hideDivisionFilter ={global_var.needDivision && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true}
            />

            <Row className='bg-white p-3 rounded-3 m-2 mt-2 d-none d-md-block'>
                <Col xs={24}>
                    <>
                        <Row>
                            <Col>
                                <span className="poppins-regular midnight-blue" style={{fontSize:'18px'}}>{questionTitle}</span>
                                <p className="poppins-regular" style={{color:'#A7A7A7'}}   > 
                                    Assigned to  
                                    <Tooltip
                                        title={renderMappings(studentMappings, false)} 
                                        overlayStyle={{
                                            maxWidth: '300px', 
                                            textAlign: 'left', 
                                            lineHeight: '1.5', 
                                        }}
                                    >
                                        <span style={{ color: '#404040', cursor: 'pointer' }}>
                                            {renderMappings(studentMappings, true)} 
                                        </span>
                                    </Tooltip>
                                    <span style={{color:'#404040'}}> with {totalCount} students </span>
                                    {selectedDate ? (<>on <span style={{ color: '#404040' }}>{formatDateMonth(selectedDate)}</span></>
                                    ) : null}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24}>
                                <div className="common-column-header">
                                    {columns.map((column, index) => {
                                    
                                        return (
                                        <div key={column.key} className="column-header poppins-bold" style={{ width: column.width }}>
                                            {index !== columns.length - 1 && ( // Check if current column is not the last one
                                                <Checkbox checked={checked[index]} onChange={() => handleCheckboxChange(index)} /> // Render checkbox
                                            )} {column.title}                            
                                        </div>
                                        );
                                    })}
                                </div>
                                {!hideEvaluatedData &&(
                                    <div style={{backgroundColor:'#F6F6F6',border:'1px solid #DFDFDF'}} className="pt-2 mt-1">
                                        <Checkbox  checked={projectChecked['evaluated']} onChange={() => handleProjectCheckboxChange('evaluated')}  className="px-2  mb-2"/>
                                        <span className="poppins-bold" style={{fontSize:'16px',color:'#404040',paddingRight:'8px'}}>Evaluated</span>
                                        <Tag className='report-submitted-tag'>{evaluatedDataCount?evaluatedDataCount:0}</Tag>
                                        <Spin spinning={isEvaluatedLoading}>
                                        {report.evaluated && report.evaluated.length > 0 &&(
                                        <>
                                            <Table dataSource={report.evaluated} columns={columns} pagination={false}
                                                style={{border:'1px solid #DFDFDF', borderTop: 'none'}}
                                                showHeader={false}
                                                key={reportKey}
                                            />
                                            <Pagination className="cs-pagination"
                                                total={evaluatedDataCount}
                                                defaultCurrent={1}
                                                onChange={(current) => {
                                                    fetchEvaluatedData(current)
                                                }}
                                                style={{ textAlign: 'right' }}
                                            />
                                        </>
                                        )}
                                        </Spin>
                                    </div>
                                )}
                                {!hideSubmittedData && (
                                    <div style={{backgroundColor:'#F6F6F6',border:'1px solid #DFDFDF'}} className="pt-2 mt-2 ">
                                        <Checkbox  checked={projectChecked['submitted']} onChange={() => handleProjectCheckboxChange('submitted')}  className="px-2  mb-2"/>
                                        <span className="poppins-bold" style={{fontSize:'16px',color:'#404040',paddingRight:'8px' }}>Pending Evaluation</span>
                                        <Tag className='report-submitted-tag'>{completedDataCount?completedDataCount:0}</Tag>
                                        <Spin spinning={isCompletedLoading}>
                                        {report.completed && report.completed.length > 0 &&(
                                            <>
                                                <Table dataSource={report.completed} columns={columnsSubmitted} pagination={false}
                                                    style={{border:'1px solid #DFDFDF', borderTop: 'none'}}
                                                    showHeader={false}
                                                    key={completedKey}
                                                />
                                                <Pagination className="cs-pagination"
                                                    total={completedDataCount}
                                                    defaultCurrent={1}
                                                    onChange={(current) => {
                                                        fetchSubmittedData(current)
                                                    }}
                                                    style={{ textAlign: 'right' }}
                                                />
                                            </>
                                        )}
                                        </Spin>
                                    </div>
                                )}
                                {!hidePendingData && (
                                    <div style={{backgroundColor:'#F6F6F6',border:'1px solid #DFDFDF'}} className="pt-2 mt-2">
                                        <Checkbox checked={projectChecked['pending']} onChange={() => handleProjectCheckboxChange('pending')} className="px-2  mb-2"/>
                                        <span className="poppins-bold" style={{fontSize:'16px',color:'#404040',paddingRight:'8px'}}>Pending Submission</span>
                                        <Tag className='report-pending-tag'>{pendingDataCount?pendingDataCount:0}</Tag>
                                        <Spin spinning={isPendingLoading}>
                                        {report.pending && report.pending.length > 0 &&(
                                            <>
                                                <Table dataSource={report.pending} columns={columnsPending}  
                                                    style={{border:'1px solid #DFDFDF', borderTop: 'none'}}
                                                    showHeader={false}
                                                    pagination={false}
                                                    key={pendingKey}
                                                />
                                                <Pagination className="cs-pagination"
                                                    total={pendingDataCount}
                                                    defaultCurrent={1}
                                                    onChange={(current) => {
                                                        fetchPendingData(current)
                                                    }}
                                                    style={{ textAlign: 'right' }}
                                                />
                                            </>
                                        )}
                                        </Spin>
                                    </div>
                                )}
                                {!hideResubmitData && (
                                    <div style={{backgroundColor:'#F6F6F6',border:'1px solid #DFDFDF'}} className="pt-2 mt-2">
                                        <Checkbox checked={projectChecked['resubmit']} onChange={() => handleProjectCheckboxChange('resubmit')} className="px-2  mb-2"/>
                                        <span className="poppins-bold" style={{fontSize:'16px',color:'#404040',paddingRight:'8px'}}>Ask for Resubmission</span>
                                        <Tag className='report-pending-tag'>{resubmitDataCount?resubmitDataCount:0}</Tag>
                                        <Spin spinning={isResubmitLoading}>
                                        {report.resubmit && report.resubmit.length > 0 &&(
                                            <>
                                                <Table dataSource={report.resubmit} columns={columnsPending}  
                                                    style={{border:'1px solid #DFDFDF', borderTop: 'none'}}
                                                    showHeader={false}
                                                    pagination={false}
                                                    key={resubmitKey}
                                                />
                                                <Pagination className="cs-pagination"
                                                    total={resubmitDataCount}
                                                    defaultCurrent={1}
                                                    onChange={(current) => {
                                                        fetchResubmissionData(current)
                                                    }}
                                                    style={{ textAlign: 'right' }}
                                                />
                                            </>
                                        )}
                                        </Spin>
                                    </div>
                                )}
                                
                            </Col>
                        </Row>
                    </>
                </Col>
            </Row>

            <Divider className="d-md-none" style={{backgroundColor:"#D7BEF7", marginTop:'110px'}}/>

            <Row className=' rounded-3 m-2 mt-3 d-md-none'>
                <Col xs={24}>
                    <>
                        <div style={{backgroundColor:'#F6F6F6',border:'1px solid #DFDFDF'}} className="pt-2 mt-1">
                            <span className="poppins-bold px-2" style={{fontSize:'16px',color:'#404040',paddingRight:'8px'}}>Evaluated</span>
                            <Tag className='report-submitted-tag'>{evaluatedDataCount}</Tag>
                            <Spin spinning={isEvaluatedLoading}>
                            {report.evaluated && report.evaluated.length > 0 &&(
                                <>
                                    <Table
                                        className="mt-2"
                                        dataSource={report.evaluated}
                                        columns={columnsExpandable}
                                        pagination={false}
                                        style={{border:'1px solid #DFDFDF', borderTop: 'none'}}
                                        showHeader={false}
                                        key={reportKey}
                                        expandable={{
                                            expandIcon: () => null,
                                            expandedRowRender: (record) => (
                                                <div>
                                                    <span className="poppins-regular" style={{fontSize:'14px', color:'#404040'}}>Feedback</span>
                                                    <Input.TextArea
                                                        value={record.evaluationFeedback}
                                                        rows={3}
                                                        onChange={(event) => handleInputChange(event.target.value, 'evaluationFeedback', record._id)}
                                                        className="mb-2"
                                                    />
                                                    <span className="poppins-regular" style={{fontSize:'14px', color:'#404040'}}>Improvement</span> 
                                                    <Input.TextArea
                                                        defaultValue={record.evaluationImprovement}
                                                        rows={3}
                                                        onChange={(event) => handleInputChange(event.target.value, 'evaluationImprovement', record._id)}
                                                    />
                                                </div>
                                            ),
                                            rowExpandable: () => true,
                                        }}
                                        rowKey="_id"
                                        expandedRowKeys={expandedRowKeys}
                                        onRow={(record) => ({
                                            onClick: (event) => {
                                                if (!event.target.closest('.ant-table-cell:last-child')) {
                                                    handleRowClick(record);
                                                }
                                            },
                                        })}
                                        rowClassName={() => 'clickable-row'}
                                    /> 
                                    <Pagination className="cs-pagination"
                                        total={evaluatedDataCount}
                                        defaultCurrent={1}
                                        onChange={(current) => {
                                            fetchEvaluatedData(current)
                                        }}
                                        style={{ textAlign: 'right' }}
                                    />
                                </>
                            )} 
                            </Spin>
                        </div> 
                        <div style={{backgroundColor:'#F6F6F6',border:'1px solid #DFDFDF'}} className="pt-2 mt-2 ">
                            <span className="poppins-bold px-2" style={{fontSize:'16px',color:'#404040',paddingRight:'8px' }}>Pending Evaluation</span>
                            <Tag className='report-submitted-tag'>{completedDataCount}</Tag>
                            <Spin spinning={isCompletedLoading}>
                            {report.completed && report.completed.length > 0 &&(
                                <>
                                    <Table className="mt-2" dataSource={report.completed} columns={columnsSubmitted} pagination={false}
                                        style={{border:'1px solid #DFDFDF', borderTop: 'none'}}
                                        showHeader={false}
                                    />
                                        <Pagination className="cs-pagination"
                                        total={completedDataCount}
                                        defaultCurrent={1}
                                        onChange={(current) => {
                                            fetchSubmittedData(current)
                                        }}
                                        style={{ textAlign: 'right' }}
                                    />
                                </>
                            )}
                            </Spin>

                        </div>
                        <div style={{backgroundColor:'#F6F6F6',border:'1px solid #DFDFDF'}} className="pt-2 mt-2">
                            <span className="poppins-bold px-2" style={{fontSize:'16px',color:'#404040',paddingRight:'8px'}}>Pending Submission</span>
                                <Tag className='report-pending-tag'>{pendingDataCount}</Tag>
                            <Spin spinning={isPendingLoading}>
                            {report.pending && report.pending.length > 0 &&(
                                <>
                                    <Table className="mt-2" dataSource={report.pending} columns={columnsPending} pagination={false} 
                                    style={{border:'1px solid #DFDFDF', borderTop: 'none'}}
                                    showHeader={false}
                                    />
                                    <Pagination className="cs-pagination"
                                        total={pendingDataCount}
                                        defaultCurrent={1}
                                        onChange={(current) => {
                                            fetchPendingData(current)
                                        }}
                                        style={{ textAlign: 'right' }}
                                    />
                                </>
                            )}
                            </Spin>
                        </div>

                        <div style={{backgroundColor:'#F6F6F6',border:'1px solid #DFDFDF'}} className="pt-2 mt-2">
                            <span className="poppins-bold px-2" style={{fontSize:'16px',color:'#404040',paddingRight:'8px'}}>Ask for Resubmission</span>
                                <Tag className='report-pending-tag'>{resubmitDataCount}</Tag>
                            <Spin spinning={isResubmitLoading}>
                            {report.resubmit && report.resubmit.length > 0 &&(
                                <>
                                    <Table className="mt-2" dataSource={report.resubmit} columns={columnsPending} pagination={false} 
                                    style={{border:'1px solid #DFDFDF', borderTop: 'none'}}
                                    showHeader={false}
                                    />
                                    <Pagination className="cs-pagination"
                                        total={resubmitDataCount}
                                        defaultCurrent={1}
                                        onChange={(current) => {
                                            fetchResubmissionData(current)
                                        }}
                                        style={{ textAlign: 'right' }}
                                    />
                                </>
                            )}
                            </Spin>
                        </div>
                    </>              
                </Col>
            </Row>

            <Modal
                title="Save"
                open={showModal} 
                onOk={() => setShowModal(false)}
                onCancel={() => setShowModal(false)}  
            >
                <p className="poppins-regular" style={{color:'#404040'}}>Please ensure to save the changes before exporting the content.</p>
            </Modal>

            <Modal
                title={(
                    <span className="poppins-bold" style={{ fontSize: '24px'}}>
                        Export as {"{pdf/xlxs}"} 
                    </span>
                )}
                open={filterModal} 
                onCancel={() => setFilterModal(false)}  
                footer={[
                    <div style={{ textAlign: 'left' }}>
                        <Button
                            key="export"
                            type="primary"
                            onClick={() => {
                                handleToExport(exportType); 
                                setFilterModal(false);
                            }}
                        >
                            Export
                        </Button>
                    </div>,
                ]}
            >
                <div>
                    <h4 className="poppins-bold mt-3" style={{fontSize:'20px',color:'#404040'}}>Fields</h4>
                    {columns.map((column, index) => {
                    
                        return (
                        <div key={column.key} className="poppins-regular" style={{fontSize:'16px', paddingTop:'6px' , color:'404040' }}>
                            {index !== columns.length - 1 && ( // Check if current column is not the last one
                                <Checkbox checked={checked[index]} onChange={() => handleCheckboxChange(index)} /> // Render checkbox
                            )} <span style={{fontSize:'16px', color:'404040' }}>{column.title}</span>                        
                        </div>
                        );
                    })}
                </div>
                <div>
                    <h4 className="poppins-bold mt-2" style={{fontSize:'20px',color:'#404040'}}>Status</h4>
                    <Checkbox  checked={projectChecked['evaluated']} onChange={() => handleProjectCheckboxChange('evaluated')}  className="mb-2"/>
                    <span className="poppins-regular px-1" style={{fontSize:'16px',color:'#404040',paddingRight:'8px'}}>Evaluated</span>
                    <p className="mb-0"><Checkbox  checked={projectChecked['submitted']} onChange={() => handleProjectCheckboxChange('submitted')}  className="mb-2"/>
                    <span className="poppins-regular px-1" style={{fontSize:'16px',color:'#404040',paddingRight:'8px' }}>Submitted</span></p>
                    <p><Checkbox checked={projectChecked['pending']} onChange={() => handleProjectCheckboxChange('pending')} className="mb-2"/>
                    <span className="poppins-regular px-1" style={{fontSize:'16px',color:'#404040',paddingRight:'8px'}}>Pending Submission</span></p>
                </div>
            </Modal>

            {isOpen && (
                <SourceCodeModal
                    isOpen={isOpen}
                    handleCancel={handleCancel}
                    currentRecord={currentRecord}
                />
            )}
            {isOpenModal && (
                <ModalComponent
                  isOpen={isOpenModal}
                  handleCancel={handleCancel}
                  assignmentObj={selectedProject}
                />
              )}
        </>
    );
};

export default AssignmentReport;